import { render, staticRenderFns } from "./PeriodWeek.vue?vue&type=template&id=107d1e6d&scoped=true"
import script from "./PeriodWeek.vue?vue&type=script&lang=ts"
export * from "./PeriodWeek.vue?vue&type=script&lang=ts"
import style0 from "./PeriodWeek.vue?vue&type=style&index=0&id=107d1e6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107d1e6d",
  null
  
)

export default component.exports